import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PageSpinner } from 'src/components/spinner-container';
import { PrimaryRemitReportsOverview } from 'src/pages/reporting/remit-reports/overview';
import {
  isRemitReportingSubscriptionInfoLoaded,
  remitReportingSubscriptionInfoLoading,
  useRemitReportingSubscriptionInfo,
} from 'src/pages/reporting/secondary-tradings/overview/use-remit-reporting-subscription-info';
import { Forbidden } from 'src/utils/errors';

export const ReportingPrimaryRemitReports: FC<{}> = ({}) => {
  const subscriptionInfoRequest = useRemitReportingSubscriptionInfo('PRIMARY');

  if (remitReportingSubscriptionInfoLoading(subscriptionInfoRequest))
    return <PageSpinner />;

  if (!isRemitReportingSubscriptionInfoLoaded(subscriptionInfoRequest))
    throw new Forbidden();

  return (
    <Switch>
      <Route path="/reporting/remit-reports">
        <PrimaryRemitReportsOverview />
      </Route>
    </Switch>
  );
};
